// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/identity_verification/verification/firstparty/v4/get_identity_verification.proto

/* oxlint-disable */
import {
  ApiEvidence,
  ApiOutcome,
  ApiProvider,
  apiProviderFromJSON,
  apiProviderToJSON,
  ApiStatus,
  apiStatusFromJSON,
  apiStatusToJSON,
} from "./identity_verification";

/** Request message for GetIdentityVerification. */
export interface ApiGetIdentityVerificationRequest {
  /** The ID of the identity verification to retrieve (UUID format). */
  readonly id: string;
}

/** Response message for GetIdentityVerification. */
export interface ApiGetIdentityVerificationResponse {
  /** The ID of the identity verification (UUID format). */
  readonly identityVerificationId: string;
  /** The ID of the identity the verification belongs to (UUID format). */
  readonly identityId: string;
  /** The provider handling the identity verification. */
  readonly provider: ApiProvider;
  /** The current status of the identity verification. */
  readonly status: ApiStatus;
  /** The evidences required or collected for this identity verification. */
  readonly evidences: readonly ApiEvidence[];
  /** The outcome of the latest evaluation, if any. */
  readonly outcome: ApiOutcome | null;
}

/** Error definitions for GetIdentityVerification. */
export interface ApiGetIdentityVerificationErrors {
}

/** Not found error codes. */
export const ApiGetIdentityVerificationErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error. */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND - Identity verification with the given ID was not found. */
  NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND: "NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND",
} as const;

export type ApiGetIdentityVerificationErrorsNotFoundError =
  typeof ApiGetIdentityVerificationErrorsNotFoundError[keyof typeof ApiGetIdentityVerificationErrorsNotFoundError];

export namespace ApiGetIdentityVerificationErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED =
    typeof ApiGetIdentityVerificationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND =
    typeof ApiGetIdentityVerificationErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND;
}

export function apiGetIdentityVerificationErrorsNotFoundErrorFromJSON(
  object: any,
): ApiGetIdentityVerificationErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiGetIdentityVerificationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND":
      return ApiGetIdentityVerificationErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND;
    default:
      return ApiGetIdentityVerificationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiGetIdentityVerificationErrorsNotFoundErrorToJSON(
  object: ApiGetIdentityVerificationErrorsNotFoundError,
): string {
  switch (object) {
    case ApiGetIdentityVerificationErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiGetIdentityVerificationErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND:
      return "NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

export const ApiGetIdentityVerificationRequest: MessageFns<ApiGetIdentityVerificationRequest> = {
  fromJSON(object: any): ApiGetIdentityVerificationRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetIdentityVerificationRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetIdentityVerificationResponse: MessageFns<ApiGetIdentityVerificationResponse> = {
  fromJSON(object: any): ApiGetIdentityVerificationResponse {
    return {
      identityVerificationId: isSet(object.identity_verification_id)
        ? globalThis.String(object.identity_verification_id)
        : "",
      identityId: isSet(object.identity_id) ? globalThis.String(object.identity_id) : "",
      provider: isSet(object.provider) ? apiProviderFromJSON(object.provider) : ApiProvider.PROVIDER_UNSPECIFIED,
      status: isSet(object.status) ? apiStatusFromJSON(object.status) : ApiStatus.STATUS_UNSPECIFIED,
      evidences: globalThis.Array.isArray(object?.evidences)
        ? object.evidences.map((e: any) => ApiEvidence.fromJSON(e))
        : [],
      outcome: isSet(object.outcome) ? ApiOutcome.fromJSON(object.outcome) : null,
    };
  },

  toJSON(message: ApiGetIdentityVerificationResponse): unknown {
    const obj: any = {};
    if (message.identityVerificationId !== undefined && message.identityVerificationId !== null) {
      obj.identity_verification_id = message.identityVerificationId;
    }
    if (message.identityId !== undefined && message.identityId !== null) {
      obj.identity_id = message.identityId;
    }
    if (message.provider !== undefined && message.provider !== null) {
      obj.provider = apiProviderToJSON(message.provider);
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiStatusToJSON(message.status);
    }
    if (message.evidences?.length) {
      obj.evidences = message.evidences.map((e) => ApiEvidence.toJSON(e));
    }
    if (message.outcome !== undefined && message.outcome !== null) {
      obj.outcome = ApiOutcome.toJSON(message.outcome);
    }
    return obj;
  },
};

export const ApiGetIdentityVerificationErrors: MessageFns<ApiGetIdentityVerificationErrors> = {
  fromJSON(_: any): ApiGetIdentityVerificationErrors {
    return {};
  },

  toJSON(_: ApiGetIdentityVerificationErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
